<script setup lang="ts">
import { useSession } from '@yc/ui-kit'
import { onMounted, ref } from 'vue'

import ChangePwdForm from '../components/ChangePwdForm.vue'

const { me } = useSession()
const done = ref(false)

onMounted(() => {
  done.value = false
})
</script>

<template>
  <div class="yc-force-pwd">
    <el-card class="yc-force-pwd__card">
      <template #header>
        <b>首次登录，请先修改密码</b>
      </template>

      <p class="yc-force-pwd__hint">
        {{ me?.must_change_pwd ? '你的账号处于待改密状态，修改完成后才能使用其他功能。' : '' }}
        新密码需为 8~64 位，且同时包含字母和数字。
      </p>

      <el-alert v-if="done" type="success" :closable="false" show-icon title="密码已修改" />
      <ChangePwdForm v-else />
    </el-card>
  </div>
</template>

<style scoped lang="scss">
.yc-force-pwd {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: var(--yc-space-6);

  &__card {
    width: 100%;
    max-width: 420px;
  }

  &__hint {
    margin: 0 0 var(--yc-space-4);
    color: var(--yc-text-secondary);
    font-size: var(--yc-font-sm);
    line-height: 1.7;
  }
}
</style>